const FORM_SELECTOR = "[data-widerruf]";

const isContactPosted = (url: string) => {
  try {
    return new URL(url).searchParams.get("contact_posted") === "true";
  } catch {
    return false;
  }
};

const showError = (errorEl: HTMLElement | null) => {
  if (!errorEl) return;
  errorEl.classList.remove("hidden");
};

const showSuccess = (fieldsEl: HTMLElement, successEl: HTMLElement, errorEl: HTMLElement | null) => {
  fieldsEl.classList.add("hidden");
  errorEl?.classList.add("hidden");
  successEl.classList.remove("hidden");
  successEl.focus();
};

const bindForm = (root: HTMLElement) => {
  if (root.dataset.widerrufInit === "true") return;

  const form = root.querySelector("form");
  const fieldsEl = root.querySelector<HTMLElement>("[data-widerruf-fields]");
  const successEl = root.querySelector<HTMLElement>("[data-widerruf-success]");
  const errorEl = root.querySelector<HTMLElement>("[data-widerruf-error]");
  const button = root.querySelector<HTMLButtonElement>("[data-widerruf-submit]");
  if (!form || !fieldsEl || !successEl || !button) return;

  root.dataset.widerrufInit = "true";

  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    if (button.disabled) return;

    errorEl?.classList.add("hidden");
    button.disabled = true;
    const originalLabel = button.textContent;
    button.textContent = button.dataset.submittingLabel || originalLabel;

    try {
      const response = await fetch(form.action, {
        method: "POST",
        body: new FormData(form),
        headers: { Accept: "text/html" },
      });

      if (!response.ok || !isContactPosted(response.url)) {
        showError(errorEl);
        return;
      }

      showSuccess(fieldsEl, successEl, errorEl);
    } catch {
      showError(errorEl);
    } finally {
      if (successEl.classList.contains("hidden")) {
        button.disabled = false;
        button.textContent = originalLabel;
      }
    }
  });
};

export const initWiderrufForm = (root: ParentNode = document) => {
  const holders = root.querySelectorAll<HTMLElement>(FORM_SELECTOR);
  for (let i = 0; i < holders.length; i++) {
    bindForm(holders[i]);
  }

  if (root instanceof HTMLElement && root.matches(FORM_SELECTOR)) {
    bindForm(root);
  }
};
